import { Container } from "@pixi/display";
import { TriangleView } from "../triangles/TriangleView";

export class SquareView extends Container {
    public constructor(
        triangles: Array<TriangleView>
    ) {
        super();
        if (triangles != null) {
            for (let i = 0; i < triangles.length; i++) {
                this.addChild(triangles[i]);
            }
        }
    }
}